/**
 * MODULE: EmailTemplateActionBadges.tsx
 * PURPOSE: Recommended + Used N× pills for email template snapshot actions.
 */

type EmailTemplateActionBadgesProps = {
  recommended?: boolean;
  uses?: number;
  tone?: 'indigo' | 'blue';
};

export function EmailTemplateActionBadges({
  recommended = false,
  uses,
  tone = 'blue',
}: EmailTemplateActionBadgesProps) {
  if (!recommended && !(uses && uses > 0)) return null;
  const recClass =
    tone === 'indigo'
      ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-950/60 dark:text-indigo-200'
      : 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300';
  return (
    <>
      {recommended ? (
        <span
          className={`rounded-full px-1.5 py-0.5 text-[10px] font-medium ${recClass}`}
          data-testid="email-template-action-recommended-badge"
        >
          Recommended
        </span>
      ) : null}
      {uses && uses > 0 ? (
        <span
          className="rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300"
          data-testid="email-template-action-uses-badge"
        >
          Used {uses}×
        </span>
      ) : null}
    </>
  );
}
